export default function Footer() {
  const col1 = [
    { label: '今日热榜', href: '#hot' },
    { label: '抢先首发', href: '#breaking' },
    { label: '平台速度排行', href: '#speed' },
    { label: '热门主题', href: '#topics' },
  ];
  const col2 = [
    { label: '深度测评', href: '#picks' },
    { label: '吃瓜口碑', href: '#reviews' },
    { label: '常见问题', href: '#faq' },
    { label: '第一时间订阅', href: '#contact' },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100/90">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                吃瓜<span className="text-primary-500">最快</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              全网热点竞速情报站，专注抢先首发与时效比拼。用速度排行帮你锁定重点，
              用对比评测帮你把瓜吃透，抢先不迷路。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['娱乐', '影视', '综艺', '音乐', '科技'].map((t) => (
                <a key={t} href="#topics" className="rounded-full bg-background-200 px-3 py-1 text-xs font-medium text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700">
                  #{t}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">热门入口</h3>
            <ul className="mt-4 space-y-2.5">
              {col1.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-600">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">关于我们</h3>
            <ul className="mt-4 space-y-2.5">
              {col2.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-600">{l.label}</a>
                </li>
              ))}
            </ul>
            <a
              href="mailto:hello@chiguazuikuai.com"
              className="mt-4 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-500"
            >
              <i className="ri-mail-line" />
              hello@chiguazuikuai.com
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 吃瓜最快 · 全网热点竞速情报站。仅提供公开信息聚合与整理。</p>
          <p className="inline-flex items-center gap-2">
            <i className="ri-flashlight-line text-primary-500" />
            更快 · 更全 · 更理性
          </p>
        </div>
      </div>
    </footer>
  );
}